/** Build identity (app/version/buildId/time/marker) resolved from Vite-injected defines. */

export interface OperatorUiBuildInfo {
  app: string;
  version: string;
  buildId: string;
  buildTime: string;
  marker: string;
  label: string;
}

export function formatBuildLabel(info: {
  version: string;
  buildId: string;
  marker?: string;
}): string {
  const base = `${info.version}+${info.buildId}`;
  return info.marker ? `${base} ${info.marker}` : base;
}

export function getOperatorUiBuildInfo(): OperatorUiBuildInfo {
  const info = {
    app: "operator-ui",
    version: __APP_VERSION__,
    buildId: __BUILD_ID__,
    buildTime: __BUILD_TIME__,
    marker: __BUILD_MARKER__,
  };
  return {
    ...info,
    label: formatBuildLabel(info),
  };
}
